import { GoogleLogo } from '@/public/image/google-logo';
import { MicrosoftLogo } from '@/public/image/microsoft-logo';
import { Box, Flex } from '@mantine/core';
import { BuiltInProviderType } from 'next-auth/providers/index';

type Props = {
  onSocialAuth: (
    provider: BuiltInProviderType,
    agent?: string,
    ref?: string
  ) => void;
  isLoadingProvider?: BuiltInProviderType | null;
  agent?: string;
  ref?: string;
  title?: string;
};

const SocialAuth = ({
  onSocialAuth,

  agent,
  ref,
  title,
}: Props) => {
  return (
    <>
      <Box className="mt-5 w-full">
        <Flex className="w-full flex-col items-center justify-center gap-3 md:flex-row">
          <div
            onClick={() => onSocialAuth('google', agent, ref)}
            className="flex h-10 w-full cursor-pointer items-center justify-center rounded border border-gray-300 text-[var(--mantine-color-exo-brand-6)] hover:bg-background"
          >
            <div className="w-[20px]">
              <GoogleLogo />
            </div>
            <span className="ml-1 text-sm">
              {title || 'Log in with'} Google
            </span>
          </div>
          <div
            onClick={() => onSocialAuth('azure-ad', agent, ref)}
            className="flex h-10 w-full cursor-pointer items-center justify-center rounded border border-gray-300 text-[var(--mantine-color-exo-brand-6)] hover:bg-background"
          >
            <div className="w-[20px]">
              <MicrosoftLogo />
            </div>

            <span className="ml-1 text-sm">
              {title || 'Log in with'} Microsoft
            </span>
          </div>
        </Flex>
      </Box>

      <Flex className="m-7 flex items-center">
        <div className="flex-1 border-t border-gray-200"></div>
        <span className="px-4 text-sm font-medium text-[var(--mantine-color-exo-brand-6)]">
          OR
        </span>
        <div className="flex-1 border-t border-gray-200"></div>
      </Flex>
    </>
  );
};

export default SocialAuth;
